import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { DEFAULT_PART2 } from '../../../supabase/functions/_shared/almaPhase2Config.ts';

/**
 * How many main questions Alma asks in Part 2: the active ones an admin has set
 * up (see /admin/alma-part2). The progress bar's total. Until it loads, or if
 * it can't, the fallback is the default set's size.
 */
export function usePart2Budget(enabled: boolean): number {
  const [budget, setBudget] = useState(DEFAULT_PART2.questions.length);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void (async () => {
      try {
        const { count, error } = await supabase
          .from('alma_part2_questions')
          .select('id', { count: 'exact', head: true })
          .eq('active', true);
        if (!cancelled && !error && count && count > 0) setBudget(count);
      } catch { /* keep the fallback */ }
    })();
    return () => { cancelled = true; };
  }, [enabled]);

  return budget;
}
